import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { motion, useScroll, useTransform } from 'framer-motion';
import { FiMail, FiPhone, FiMapPin } from 'react-icons/fi';

import '../styles/Institucional.css';

import portadaImg from '../assets/images/portada.webp';
import historiaImg from '../assets/images/foto-historia.jpg';
import autoridadesImg from '../assets/images/autoridades.webp'; // <-- Añadido: Importación de la nueva imagen

const QuienesSomos = () => (
    <section id="quienes-somos" className="page-section-institucional" data-aos="fade-up">
        <div className="container-institucional">
            <h2 className="section-title-institucional">Quiénes Somos</h2>
            <div className="content-box-institucional">
                <p>Somos una entidad sin fines de lucro conformada con la finalidad de integrar y representar a las instituciones y profesionales que participan en la vida del sector empresario de la salud.</p>
                <p>Por medio de nuestros servicios, dotamos a las empresas de salud de las modernas herramientas que requiere hoy la gestión empresaria para mejorar la calidad, disminuir los costos y satisfacer al usuario.</p>
                <p>De esta manera promovemos, estimulamos y prestigiamos emprendimientos e intercambios entre sus integrantes, conjugando los intereses de la oferta y la demanda.</p>

                <div className="autoridades-box">
                    <h3 className="autoridades-title">Nuestras Autoridades</h3>
                    <ul className="autoridades-list">
                        <li><strong>DR. MIGUEL RODRIGUEZ</strong> — Presidente</li>
                        <li><strong>DR. RODOLFO LESBEGUERIS</strong> — Vicepresidente</li>
                        <li><strong>DR. RODOLFO TORRES</strong> — Secretario</li>
                        <li><strong>DR. IGNACIO ESCUTI</strong> — Prosecretario</li>
                        <li><strong>DR. AMADOR PALAVECINO</strong> — Tesorero</li>
                        <li><strong>DR. FAVIO MESTAS NÚÑEZ</strong> — Protesorero</li>
                        <li><strong>DR. MANUEL IGLESIAS</strong> — Vocal</li>
                        <li><strong>LIC. ALEJANDRA RODRIGUEZ</strong> — Vocal</li>
                        <li><strong>DR. MARIANO JOZAMI</strong> — Vocal</li>
                        <li><strong>DR. GUSTAVO IRICO</strong> — Órgano de fiscalización</li>
                    </ul>
                    {/* --- Añadido: Imagen de autoridades --- */}
                    <figure className="autoridades-figure">
                        <img src={autoridadesImg} alt="Foto de las autoridades de CAES" className="autoridades-img" />
                    </figure>
                </div>
            </div>
        </div>
    </section>
);

const Historia = () => (
    <section id="historia" className="page-section-institucional alternate-bg" data-aos="fade-up">
        <div className="container-institucional">
            <h2 className="section-title-institucional">Nuestra Historia</h2>
            <div className="content-box-institucional">
                <p>El 31 de agosto de 1994, un grupo de dirigentes nacionales de la Salud que concurríamos a las reuniones de la Confederación Argentina de Clínicas, Sanatorios y Hospitales Privados (CONFECLISA), decidimos fundar la Cámara Argentina de Empresas de Salud (CAES) con el objetivo de dar participación al Sector Científico, Comercial, Comunicacional, Laboral y demás partícipes del quehacer de la Salud.</p>
                <p>Comenzamos, además, a desarrollarnos activamente en el plano educacional y de capacitación a través de cursos, jornadas y congresos. La idea central era que la CAES se constituyera en un foro permanente de debate e intercambio de ideas y contacto con otras entidades del mundo, para conocer todos los aspectos de los cuales nos pudiéramos nutrir, para el mejoramiento de la calidad de los servicios en beneficio de los pacientes que son, en definitiva, la razón de nuestra existencia.</p>
                <p>Con estas bases, la nueva Entidad pronto recibió la adhesión de personas, así como instituciones, universidades, laboratorios, empresas, proveedores y medios de comunicación; todos los cuales se acercaron hasta confluir en nuestro I Congreso Internacional Salud, Crisis y Reforma, en el año 1995, bajo el lema: “Propuestas para la Reforma”. La Salud merecía un debate político, la crisis era muy profunda y la reforma se hacía necesaria.</p>
                <p>Desde entonces seguimos con la responsabilidad de organizar nuestro Congreso.</p>
                <p>Nuestro objetivo sigue siendo proponer debates políticos para el mejoramiento de los Sistemas de Salud, aportando herramientas concretas para optimizar las funciones de todas las áreas de los Establecimientos Asistenciales.</p>
                <p>El Resultado de nuestros encuentros son aportes para los gobiernos nacional, provinciales y municipales, para mejorar el acceso y la calidad de los servicios.</p>
                <p className="history-founders"><strong>Presidentes:</strong> Dn. Norberto Hugo Larroca (1994-2002), Dr. Juan Antonio Larzabal (2002-2010), Dr. Carlos Noceti (2010-2016), CP Aldo Rodolfo Yunes (2016-2025), Dr Miguel Rodriguez (Actualidad)</p>
                <figure className="historia-figure">
                    <img src={historiaImg} alt="Fundadores de la CAES en 1994" className="historia-img" />
                    <figcaption className="historia-caption">
                        Carlos Noceti – Armando Frangioli - Norberto Larroca - Juan Antonio Larzabal - Ángel Vincitorio.
                    </figcaption>
                </figure>
            </div>
        </div>
    </section>
);

const Asociese = () => (
    <section id="asociese" className="page-section-institucional" data-aos="fade-up">
        <div className="container-institucional">
            <h2 className="section-title-institucional">Asóciese</h2>
            <div className="content-box-institucional">
                <p>La CAES genera un vínculo transparente entre la oferta y la demanda de servicios para las empresas de salud. La asociación a nuestra entidad representa el acceso a información imprescindible para desarrollar sus tareas y la posibilidad de adquirir los servicios que necesita a un precio promocional.</p>
                <h4 className="asociese-subtitle">¿Quiénes pueden asociarse?</h4>
                <p>Profesionales, empresarios, dirigentes, directivos, instituciones y empresas del sector salud o que están en relación con él y todos aquellos que tengan que tomar decisiones dentro de las organizaciones del sector.</p>

                {/* --- NUEVO BLOQUE DE CONTACTO --- */}
                <div className="asociese-contact-info">
                    <p className="contact-info-subtitle">Para más información sobre cómo asociarse, contáctenos:</p>
                    <div className="contact-details-list">
                        <a href="mailto:caes@caes.org.ar" className="contact-detail-item">
                            <FiMail className="contact-icon" />
                            <span>caes@caes.org.ar</span>
                        </a>
                        <a href="tel:+541152565093" className="contact-detail-item">
                            <FiPhone className="contact-icon" />
                            <span>(54-11) 5256-5093</span>
                        </a>
                        <div className="contact-detail-item">
                            <FiMapPin className="contact-icon" />
                            <span>Tucumán 1668 Piso 2 (CABA)</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);


function Institucional() {
  const location = useLocation();
  const [activeSection, setActiveSection] = useState('quienes-somos');

  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end start"]
  });
  const parallaxY = useTransform(scrollYProgress, [0, 1], ["0%", "20%"]);

  useEffect(() => {
    AOS.init({
        duration: 800,
        once: true,
        easing: 'ease-in-out',
    });
  }, []);

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash) {
      setActiveSection(hash);
    } else {
      setActiveSection('quienes-somos');
      window.scrollTo(0, 0);
    }
  }, [location]);

  const renderSection = () => {
    switch (activeSection) {
      case 'quienes-somos':
        return <QuienesSomos />;
      case 'historia':
        return <Historia />;
      case 'asociese':
        return <Asociese />;
      default:
        return <QuienesSomos />;
    }
  };

  return (
    <div className="institucional-page-container" ref={containerRef}>
        <motion.div
          className="institucional-background-image"
          style={{ 
            backgroundImage: `url(${portadaImg})`,
            y: parallaxY 
          }}
        />
        
        <main className="main-content-institucional">
            {renderSection()}
        </main>
    </div>
  );
}

export default Institucional;